import React, { Component } from "react";
import { withTranslation } from "react-i18next";
import SysForm from "../../commonComponents/sysForm";
import { post } from "../../../utils/sysAxios";
import { Dialog } from "primereact/dialog";
import { Button } from "primereact/button";
import SysTable from "../../commonComponents/SysTable";
import sysJwt from "../../../utils/sysJwt";

class UserManagement extends Component {
  state = {
    data: {
      type: "",
      typeId: "",
      ownerId: "",
      compoundId: "",
      title: "",
      body: "",
      topic: "",
    },

    contentHeader: "Notifications",
    addButtonLabel: "Send New Notif.",
    addButtonIcon: "fa fa-plus",

    dataUrl: "/api/data/getpublicnotf",
    addUrl: "/api/data/sendpublicnotf",

    inModalMode: false,
    modalHeaderAdd: "Send Notification",
    modalSubmitButtonLabelAdd: "Send",
    modalSubmitButtonIconAdd: "fa fa-plus",
    modalWidth: "50vw",

    topicDropdown: [],
    allUnitType: [],
    allOwner: [],
    allCompound: [],
    allType: [
      { value: "1", label: "Public" },
      { value: "2", label: "Unit Type" },
      { value: "3", label: "Owner" },
      { value: "4", label: "Compound" },
    ],

    tableData: [],
  };

  getColumns() {
    const { t } = this.props;
    return [
      {
        id: 1,
        label: t("col.title"),
        field: "TITLE",
      },
      {
        id: 2,
        label: t("col.body"),
        field: "BODY",
      },
      {
        id: 3,
        label: t("col.insertDate"),
        field: "INSERT_DATE",
      },
      {
        id: 4,
        label: t("col.lastUpdate"),
        field: "LAST_UPDATE",
      },
    ];
  }

  componentDidMount() {
    this.getData();
    this.getAllOwner();
    this.getUnitTypesDropdown();
    this.getCompoundsDropdown();
  }

  getUnitTypesDropdown() {
    post(
      "/api/data/GetAllUnitTypesDropdown",
      null,
      this.props.updateIsLoading
    ).then((apiResponse) => {
      this.setState({
        allUnitType: apiResponse.data.respData.data,
      });
    });
  }

  getCompoundsDropdown() {
    post(
      "/api/data/GetAllCompoundsDropdown",
      null,
      this.props.updateIsLoading
    ).then((apiResponse) => {
      this.setState({ allCompound: apiResponse.data.respData.data });
    });
  }

  getAllOwner() {
    post("/api/data/getallowner", null, this.props.updateIsLoading).then(
      (apiResponse) => {
        this.setState({
          allOwner: apiResponse.data.respData.data,
        });
      }
    );
  }

  updateForm = (inputId, inputValue) => {
    var data = this.state.data;
    data[inputId] = inputValue;
    this.setState({ data });
  };

  showForm() {
    this.setState({ inModalMode: true });

    this.getTopicDropdown();
  }

  closeModal() {
    var data = this.state.data;

    Object.keys(data).forEach(function (key) {
      Array.isArray(data[key]) ? (data[key] = []) : (data[key] = "");
    });

    this.setState({
      inModalMode: false,
      data: data,
      topicDropdown: [],
    });

    this.getData();
  }

  getData() {
    post(this.state.dataUrl, null, this.props.updateIsLoading).then(
      (apiResponse) => {
        this.setState({ tableData: apiResponse.data.respData.data });
      }
    );
  }

  getTopicDropdown() {
    post("/api/data/getallfcmtopic", null, this.props.updateIsLoading).then(
      (apiResponse) => {
        this.setState({
          topicDropdown: apiResponse.data.respData.data,
        });
      }
    );
  }

  doSubmit() {
    const submitData = Object.assign({}, this.state.data);

    post(this.state.addUrl, submitData, this.props.updateIsLoading).then(
      (apiResponse) => {
        if (apiResponse.data.respCode === 0) {
          this.props.updateIsLoading(false);
          this.closeModal();
        }
      }
    );
  }

  render() {
    const { t } = this.props;
    return (
      <div className="bms-content-component fade-in">
        <div className="row">
          <div className="col">
            <h4>{t("pages.notifications")}</h4>
          </div>
          <div className="col flex-container-left">
            {sysJwt.isAuthorized(["CB11"]) && (
              <Button
                label={t("pages.addNotification")}
                icon={this.state.addButtonIcon}
                className="p-button-rounded p-button-secondary"
                disabled={this.props.isLoading}
                onClick={() => {
                  this.showForm();
                }}
              />
            )}
          </div>
        </div>
        <hr />
        <Dialog
          visible={this.state.inModalMode}
          style={{ width: this.state.modalWidth }}
          onHide={(e) => this.closeModal()}
          dismissableMask={true}
          closable={false}
          header={<h5 className="modal-header">{t("dialog.addTitle")}</h5>}
          footer={
            <div>
              <Button
                label={t("btn.send")}
                icon={this.state.modalSubmitButtonIconAdd}
                className="p-button-rounded p-button-secondary"
                disabled={this.props.isLoading}
                onClick={() => this.doSubmit()}
              />
              <Button
                label={t("btn.cancel")}
                icon="fa fa-close"
                className="p-button-rounded p-button-danger"
                onClick={() => this.closeModal()}
              />
            </div>
          }
        >
          <SysForm
            isLoading={this.props.isLoading}
            inEditMode={false}
            data={this.state.data}
            updateForm={this.updateForm}
            inputs={[
              {
                type: "dropdown",
                id: "type",
                label: t("col.type"),
                options: this.state.allType,
                disabled: false,
              },
              {
                type: "dropdown",
                id: "topic",
                label: t("col.fcmTopic"),
                options: this.state.topicDropdown,
                disabled: this.state.data.type === "1" ? false : true,
              },
              {
                type: "dropdown",
                id: "typeId",
                label: t("col.unitType"),
                options: this.state.allUnitType,
                disabled: this.state.data.type === "2" ? false : true,
              },
              {
                type: "dropdown",
                id: "ownerId",
                label: t("col.owner"),
                options: this.state.allOwner,
                disabled: this.state.data.type === "3" ? false : true,
                },
                {
                  type: "dropdown",
                  id: "compoundId",
                  label: t("col.compound"),
                  options: this.state.allCompound,
                  disabled: this.state.data.type === "4" ? false : true,
                },
                {
                    type: "text",
                    id: "title",
                    label: t("col.title"),
                    disabled: false,
                },
              {
                type: "text",
                id: "body",
                label: t("col.body"),
                disabled: false,
              },
            ]}
          />
        </Dialog>
        <SysTable
          columns={this.getColumns()}
          rows={this.state.tableData}
          pageSizes={[10, 15, 20, 25, 30]}
        />
      </div>
    );
  }
}

export default withTranslation()(UserManagement);
